import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { getToken } from '../auth/auth.function';

// ä»å¾çURLä¸­éåºåä¸ªå¾ï¼æå¨é¨
export function imgUrl(imageUrl: string, index: string | number ): string | string[] {
    if ( index === 'all' ) {
        return imageUrl ? `${imageUrl.split(',').map( x => (getToken().picServerUrl + x ))}` : '';
    } else {
        return imageUrl ? `${getToken().picServerUrl}${imageUrl.split(',')[index]}` : '';
    }
}

@Pipe({ name: 'imagePipe' })
export class ImgUrlPipe implements PipeTransform {
    public transform(value: any, optionalItem: string | number): string | string[] {
        return imgUrl(value, optionalItem);
    }
}

@NgModule({
    declarations: [ImgUrlPipe],
    exports: [ImgUrlPipe]
})
export class ImgUrlPipeModule {
}
